// ============================================================================
// openOverlays — how many modals and drawers are open right now
// (Design Constitution Table C "Where the bar hides", N02)
// ----------------------------------------------------------------------------
// Every dialog shell traps focus through useModalFocusTrap, which registers
// here while it is mounted, so the shared Modal, Drawer, Confirm, Delete, the
// Pasture area modal and the task photo viewer all count without each one
// knowing about the header. Header hides the phone bottom bar while the count
// is above zero. A plain module store read with useSyncExternalStore.
// ============================================================================
import {useSyncExternalStore} from 'react';

let open = 0;
const listeners = new Set<() => void>();
const publish = () => listeners.forEach((l) => l());

/** An overlay opened; call the returned function when it closes. */
export function registerOpenOverlay(): () => void {
  open += 1;
  publish();
  let done = false;
  return () => {
    if (done) return;
    done = true;
    open -= 1;
    publish();
  };
}

export function getOpenOverlayCount(): number {
  return open;
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function useOpenOverlayCount(): number {
  return useSyncExternalStore(subscribe, getOpenOverlayCount, getOpenOverlayCount);
}
